// extracted by mini-css-extract-plugin
export default {"historyJson":"ChangeHistory_historyJson__ZWo3Y","searchMenu":"ChangeHistory_searchMenu__YDAcu","searchBar":"ChangeHistory_searchBar__YPIc1"};